import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { AgtSocialMediaVM } from 'app/stores/ui/agt.socialmedia.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum, formatNumTwoDig } from 'app/utils';
import { SocialMediaBmRangeOptions } from './SocialMediaOptions';

export const FacebookListe = observer(() => {
	const { berichteUiiStore, agtSocialMediaUiStore, agenturListUiStore, session } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtSocialMediaVM, number>();
	const cols: ITableColumn<AgtSocialMediaVM, number>[] = [];

	const currentYear = agtSocialMediaUiStore.currentYear;

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	if (session.isMulti || session.isAdmin) {
		cols.push({
			label: 'GP',
			path: 'hasMoreThan30kViewsMultiGp26',
			render(row) {
				return <>{row.data.hasMoreThan30kViewsMultiGp26 ? <Icon iconClass="check-circle" faModifier="far" /> : <></>}</>;
			},
			agg: [
				{
					aggType: AggregrationType.count,
				},
			],
		});
		cols.push({
			label: 'Teilhaber',
			path: `agt.thCount`,
			agg: [
				{
					aggType: AggregrationType.sum,
				},
			],
		});
	}

	cols.push({
		label: 'Link',
		path: 'currFb.link',
		sortBy: 'currFb.link',
		render: (row: TableRow<AgtSocialMediaVM>) => {
			return row.data.currFb && row.data.currFb.url ? (
				<a href={row.data.currFb.url} className="color-primary" target="_blank" rel="noreferrer">
					<Icon iconClass="external-link" />
				</a>
			) : (
				<></>
			);
		},
	});

	cols.push({
		label: 'Status',
		path: `currFb.status`,
		sortBy: `currFb.status`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currFb && row.data.currFb.status === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	cols.push({
		label: 'Fans',
		path: `currFb.fans`,
		sortBy: `currFb.fans`,
		agg: [{ aggType: AggregrationType.avg }],
	});

	cols.push({
		label: 'Fans VJ',
		path: `prevFb.fans`,
		sortBy: `prevFb.fans`,
		agg: [{ aggType: AggregrationType.avg }],
	});

	cols.push({
		label: `Beiträge ${currentYear}`,
		path: `fbPostsYtd`,
		sortBy: `fbPostsYtd`,
		agg: [
			{
				aggType: AggregrationType.avg,
				format: formatNumTwoDig,
			},
		],
		format: formatNum,
	});

	cols.push({
		label: `Eigene Beiträge ${currentYear}`,
		path: `fbOwnPostsYtd`,
		sortBy: `fbOwnPostsYtd`,
		agg: [
			{
				aggType: AggregrationType.avg,
				aggIf: (val: any) => val >= 0,
				format: formatNumTwoDig,
			},
		],
		format: formatNum,
	});

	cols.push({
		label: `Ansichten ${currentYear}`,
		path: `fbViewsYtd`,
		sortBy: `fbViewsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: 'Abo PR',
		path: `currFb.aboPr`,
		sortBy: `currFb.aboPr`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currFb && row.data.currFb.aboPr === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	cols.push({
		label: 'Abo 1890',
		path: `currFb.abo1890`,
		sortBy: `currFb.abo1890`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currFb && row.data.currFb.abo1890 === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtSocialMediaUiStore.loadBySelectedRange().then((vms) => {
			let items = vms.filter((x) => x.fbs.length > 0);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtSocialMediaVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtSocialMediaUiStore, agtSocialMediaUiStore.selectedMinBm, agtSocialMediaUiStore.selectedMaxBm]);

	return (
		<>
			<SocialMediaBmRangeOptions />
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
